import { PlayerLeaderboardRank } from '@wwe-portal/entities/leaderboard.type';
import { FC } from 'react';
import { PlayerLeaderboard } from './player-leaderboard';
import { LeaderboardHead } from './leaderboard-head';
import { formatDateTime } from '@wwe-portal/utils/date';

export const PlayerLeaderboardBlock: FC<{
  leaderboard: {
    eventId: string;
    isLive: boolean;
    name: string;
    endDate: string;
    players: PlayerLeaderboardRank[];
  };
  moreHref: string;
}> = ({ leaderboard, moreHref }) => {
  const header = (
    <LeaderboardHead
      isLive={leaderboard.isLive}
      name={leaderboard.name}
      moreHref={moreHref}
      moreText="See Top 1000"
    />
  );
  return (
    <div>
      <PlayerLeaderboard
        compact={false}
        data={leaderboard.players.map((player) => ({
          points: player.playerPoints,
          rank: player.playerRank,
          playerId: player.userId,
          player: player.playerName,
          name: player.playerName,
          faction: player.factionName,
          userId: player.userId,
        }))}
        mobileHeader={header}
        desktopHeader={header}
        containerClassnames="min-h-[936px]"
      />
      <div className="text-text600 mt-4 text-xs font-medium">
        {leaderboard.isLive ? null : (
          <>Ended on {formatDateTime(leaderboard.endDate, 'DD')}</>
        )}
      </div>
    </div>
  );
};
